export type { ProductFamiliesProps } from './product-families';
export * from './product-families.routes';

export { default as ProductFamilies, default } from './product-families';
